import {Component, Host, h, Prop, EventEmitter, Event} from '@stencil/core';
import {Logger} from "../../utils/logger";

@Component({
  tag: 'securecall-response-button',
  styleUrl: 'securecall-response-button.css',
  shadow: true,
})
export class SecurecallResponseButton {
  @Prop() fieldName: string;
  @Prop() label: string;
  @Prop() action: string = "retryClearCVV";

  @Event() responseButtonEvent: EventEmitter<string>;

  private readonly log = new Logger('SecurecallResponseButton')

  handleClick() {
    this.log.debug("handleClick: field", this.fieldName, "clicked");
    this.responseButtonEvent.emit(this.action);
  }

  render() {
    return (
      <Host>
        <div class="response-field-container">
          <button type="button" class="response-button"
                  onClick={() => this.handleClick()}>
            {this.label}
          </button>
        </div>
      </Host>
    );
  }
}
